if (!customElements.get('featured-video')) {
  class FeaturedVideo extends HTMLElement {
    constructor() {
      super();

      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', (e) => {
        });
      }
      this.playOnHover = this.getAttribute("data-play-on-hover") === "true";

      this.initFeaturedVideo();
      this.initHandleChange(this);

    }

    connectedCallback() {}

    initFeaturedVideo() {
      console.log('-- INIT FEATURE');
      console.log(this.playOnHover, this.getAttribute("data-play-on-hover"));
      if (this.playOnHover) {
        this.initPlayOnHover();
      } else {
        this.querySelector('.video-play').addEventListener('click', (e) => {
          let embed = e.target.closest('.embed-wrapper');
          embed.classList.add('play');
          embed.querySelector('video').play();
          this.setAttribute('play', 'true');
        })
      }
    }

    initPlayOnHover() {
      this.addEventListener('mouseenter', () => {
        console.log('TESTING 0123213123');
        let embed = this.querySelector('.embed-wrapper');
        embed.classList.add('play');
        embed.querySelector('video').play();
        this.setAttribute('play', 'true');
      });
      this.addEventListener('mouseleave', () => {
        let embed = this.querySelector('.embed-wrapper');
        embed.classList.remove('play');
        embed.querySelector('video').pause();
        this.removeAttribute('play');
      });
    }

    initHandleChange(featuredVideo) {
      const video = this.querySelector('video');
      const sectionHeader = this.querySelector('.section-header');

      if (!video || !sectionHeader) {
        console.warn('Video or sectionHeader not found.');
        return;
      }

      const embed = video.closest('.embed-wrapper');

      const setPlayingState = () => {
        if (embed) {
          featuredVideo.setAttribute('play', 'true');
          embed.classList.add('play');
        }
      };

      const clearPlayingState = () => {
        if (embed) {
          featuredVideo.removeAttribute('play');
          embed.classList.remove('play');
        }
      };

      video.addEventListener('playing', setPlayingState);
      video.addEventListener('play', setPlayingState);

      video.addEventListener('ended', () => {
        clearPlayingState();
      });

      sectionHeader.addEventListener('click', (event) => {
        if (!event.target.closest('a') && embed) {
          setPlayingState();
          video.play().catch((err) => {
            console.error('Error playing video:', err);
          });
        }
      });
    }
  }

  customElements.define('featured-video', FeaturedVideo);
}
